export default __webpack_public_path__ + "static/media/image2-5.96253d66.png";